module.exports = __webpack_public_path__ + "img/TX2.984c3f76.svg";